import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
const useStyles = makeStyles((theme) => ({
    root: {
        "& > *": {
            margin: theme.spacing(1)
        }
    },
    input: {
        display: "none"
    }
}));
export function CsvUploader({ onChangeHandler, onClickHandler }) {
    const classes = useStyles();

    return (
        <>
            <div className={classes.root}>
                <input
                    accept="text/*"
                    className={classes.input}
                    id="contained-button-file"
                    //multiple
                    type="file"
                    onChange={onClickHandler}
                />
                <label htmlFor="contained-button-file">
                    <Button variant="contained" color="primary" component="span">
                        Feltölt
                    </Button>
                </label>
            </div>
            {/* <input type="file" onChange={onChangeHandler} />
            <button onClick={onClickHandler}>
                Upload!
            </button> */}
        </>
    )
}